import { Component } from '@angular/core';
import { soundpostReconBalanceSnapshotEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Recon Balance Snapshots') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreconbalancesnapshot-form',
    templateUrl: './soundpostreconbalancesnapshot.form.component.html'
})
export class soundpostReconBalanceSnapshotFormComponent extends BaseFormComponent {
    public record!: soundpostReconBalanceSnapshotEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

